export default "__VITE_ASSET__1d40266f__"